<template>
	<div class="JNPF-common-layout">
		<div class="JNPF-common-layout-center">
			<el-row class="JNPF-common-search-box" :gutter="16" v-if="historyPage">
				<el-form @submit.native.prevent>
					<el-col :span="6">
						<el-form-item label="运行时间">
							<el-date-picker v-model="pickerVal" type="datetimerange" start-placeholder="开始时间"
								end-placeholder="结束时间" :picker-options="pickerOptions"
								value-format="yyyy-MM-dd HH:mm:ss" :default-time="['23:59:59', '23:59:59']" clearable
								:editable="false" :append-to-body="false" />
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="车牌号">
							<el-input v-model="query.licensePlate" placeholder="请输入" clearable disabled>
							</el-input>
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item label="车辆vin码">
							<el-input v-model="query.vehicleVin" placeholder="请输入" clearable disabled>
							</el-input>
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item>
							<el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
							<!-- <el-button
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="carMoveMarker2()"
                >暂停</el-button
              > -->
							<el-button icon="el-icon-refresh-right" @click="reset()">重置</el-button>
							<!-- <el-button
                type="text"
                icon="el-icon-arrow-down"
                @click="showAll = true"
                v-if="!showAll"
              >
                展开
              </el-button>
              <el-button
                type="text"
                icon="el-icon-arrow-up"
                @click="showAll = false"
                v-else
              >
                收起
              </el-button> -->
						</el-form-item>
					</el-col>
				</el-form>
			</el-row>
			<el-row class="JNPF-common-search-box" :gutter="16" v-if="!historyPage">
				<el-form @submit.native.prevent>
					<el-col :span="6">
						<el-form-item label="车辆vin码">
							<el-input v-model="query.vehicleVin" placeholder="请输入" clearable>
							</el-input>
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item label="所在城市">
							<el-cascader ref="addressCopy" :options="optionsCity" v-model="provinces" clearable
								:append-to-body="false" @change="onCityChange" :props="{ value: 'id', label: 'name'}">
							</el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="车辆状态">
							<el-select v-model="query.engineStatus" placeholder="请选择" clearable filterable
								:popper-append-to-body="false">
								<el-option v-for="(item, index) in stationOptions" :key="index" :label="item.fullName"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<template v-if="showAll">
						<el-col :span="6">
							<el-form-item label="车牌号">
								<el-input v-model="query.licensePlate" placeholder="请输入" clearable>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="车辆品牌">
								<el-select v-model="query.vehicleBrand" placeholder="请选择" clearable filterable
									:popper-append-to-body="false">
									<el-option v-for="(item, index) in vehicleBrandOptions" :key="index"
										:label="item.fullName" :value="item.id" :disabled="item.disabled"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="6">
							<el-form-item label="车辆型号">
								<el-select v-model="query.vehicleModel" placeholder="请选择" clearable filterable
									:popper-append-to-body="false">
									<el-option v-for="(item, index) in vehicleModelOptions" :key="index"
										:label="item.fullName" :value="item.id" :disabled="item.disabled"></el-option>
								</el-select>

							</el-form-item>
						</el-col> -->

						<el-col :span="6">
							<el-form-item label="车辆类型">
								<el-select v-model="query.vehicleType" placeholder="请选择" clearable filterable
									:popper-append-to-body="false">
									<el-option v-for="(item, index) in carOptions" :key="index" :label="item.fullName"
										:value="item.id" :disabled="item.disabled"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</template>

					<el-col :span="6">
						<el-form-item>
							<el-button type="primary" :loading="loading" icon="el-icon-search" @click="search()">查询
							</el-button>
							<el-button icon="el-icon-refresh-right" @click="reset()">重置</el-button>
							<el-button type="text" icon="el-icon-arrow-down" @click="showAll = true" v-if="!showAll">
								展开
							</el-button>
							<el-button type="text" icon="el-icon-arrow-up" @click="showAll = false" v-else>
								收起
							</el-button>
						</el-form-item>
					</el-col>
				</el-form>
			</el-row>
			<div class="JNPF-common-layout-main JNPF-flex-main">
				<div class="JNPF-common-head">
					<!-- <div><el-button @click="initGrah">初始化图</el-button></div> -->
					<div>
						<el-row class="line-wrap" v-if="historyPage">
							<el-breadcrumb separator="/">
								<el-breadcrumb-item>
									<!--  @click="back" -->
									<el-link :underline="false" @click="manyCarMonitorBack" icon="el-icon-back"
										style="font-family: PingFangSC-Regular;font-size: 14px;color: rgba(0,0,0,0.45);line-height: 22px;">
										多车监控</el-link>
								</el-breadcrumb-item>
								<el-breadcrumb-item
									style="font-family: PingFangSC-Regular;font-size: 14px;color: #333333;text-align: left;line-height: 22px;">
									历史轨迹</el-breadcrumb-item>
							</el-breadcrumb>
						</el-row>
					</div>
					<div class="JNPF-common-head-right">
						<el-tooltip effect="dark" content="刷新" placement="top">
							<el-link icon="icon-ym icon-ym-Refresh JNPF-common-head-icon" :underline="false"
								@click="reset()" />
						</el-tooltip>
						<screenfull :isContainer="true" />
					</div>
				</div>
				<!-- 地图区域 -->
				<div class="total-wrap">
					<!-- <div></div> -->
					<div class="side" v-loading="loading">
						<div v-if="!historyPage">
							<div class="list-change">
								<el-row>
									<el-col :span="12">
										<span :class="active == 0 ? 'all active' : 'all'"
											@click="changeActive(0)">全部({{ this.listDatas.length }})</span>
									</el-col>
									<el-col :span="12">
										<span v-if="this.alarmNum" @click="changeActive(1)"
											:class="active == 1 ? 'alarm active' : 'alarm'">告警({{ this.alarmNum }})</span>

										<span v-else @click="changeActive(1)"
											:class="active == 1 ? 'alarm active' : 'alarm'">告警</span>
									</el-col>
								</el-row>
							</div>
							<!-- v-infinite-scroll="loadA"
                infinite-scroll-disabled="disabled" -->
							<ul class="car-list" v-infinite-scroll="loadA" infinite-scroll-disabled="disabled">
								<!-- v-if="index<countA" -->
								<li :class="index == chooseIndex ? 'bge5' : ''" @click="clickMarker(item, index)"
									v-for="(item, index) in listDatas" :key="index" v-show="index<countA">
									<el-row>
										<el-col :span="9">
											<el-row>
												<el-col :span="24" class="title-l">车牌号</el-col>
												<el-col :span="24">{{ item.licensePlate }}</el-col>
											</el-row>
										</el-col>
										<el-col :span="8">
											<el-row>
												<el-col :span="16" class="title-l" style="text-align: center;">状态
												</el-col>
												<el-col :span="24">
													<span v-if="item.engineStatus == '离线'"
														class="statusText offline">离线</span>
													<span v-if="item.engineStatus == '行驶'"
														class="statusText online">行驶</span>
													<span v-if="item.engineStatus == '静止'"
														class="statusText static">静止</span>
												</el-col>
											</el-row>
										</el-col>
										<el-col :span="7">
											<el-row>
												<el-col :span="24" class="title-l">电池SOC:</el-col>
												<el-col :span="12" style="color:#76DE79">
													<span v-if="item.soc < 50 && item.soc >= 20"
														style="color:#FDDD74"><span
															style="font-size:18px">{{ item.soc }}</span>%</span>
													<span v-if="item.soc >= 0 && item.soc < 20"
														style="color:#F97E7E"><span
															style="font-size:18px">{{ item.soc }}</span>%</span>
													<span v-if="item.soc >= 50" style="color:#76DE79"><span
															style="font-size:18px">{{ item.soc }}</span>%</span>
												</el-col>
											</el-row>
										</el-col>
									</el-row>

									<el-row>
										<el-col :span="24" class="hidden-text">
											<el-tooltip class="item" effect="dark" :content="item.address"
												placement="top-end">
												<span>
													{{ item.address }}
												</span>
											</el-tooltip>

										</el-col>
									</el-row>
								</li>
							</ul>
							<div style="height:10px;"></div>
							<div class="baseSty" v-if="loadingA">加载中...</div>
							<div class="baseSty" v-if="noMoreA">没有更多了</div>
							
						</div>
						<!-- 历史轨迹的列表 -->
						<div v-if="historyPage">
							<div class="list-change">
								<el-col style="padding:10px">
									该时间段内行驶里程（km）：{{kmNum}}
								</el-col>
								<el-row style="padding:10px 8px 0">
									共有{{
                    listDatasHistory.length ? listDatasHistory.length : "0"
                  }}条轨迹
								</el-row>
							</div>
							<ul class="car-list-history" v-infinite-scroll="load" style="overflow:auto">
								<li :class="index == chooseIndex2 ? 'bge5' : ''"
									@click="clickMarkerHistory(item, index)" v-for="(item, index) in listDatasHistory"
									:key="index">
									<el-row>
										<el-col :span="8"></el-col>
										<el-col :span="14" class="hidden-text">
											<el-image style="width: 18px;height: 18px;vertical-align: bottom;"
												:src="require('@/assets/images/car/line_icon.png')" :fit="'fill'">
											</el-image>
											轨迹{{ index + 1 }}
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="7">时间：</el-col>
										<el-col :span="17">
											<el-row>{{ item.startDate }}</el-row>
											<el-row>{{ item.endDate }}</el-row>
										</el-col>
									</el-row>
									<el-row style="padding: 5px 0;">
										<el-col :span="8">起点</el-col>
										<el-col :span="14" class="hidden-text">
											<el-tooltip class="item" effect="dark" :content="item.startAddress"
												placement="top-end">
												<span>
													{{ item.startAddress }}
												</span>
											</el-tooltip>

										</el-col>
									</el-row>
									<el-row style="padding: 5px 0;">
										<el-col :span="8">终点</el-col>
										<el-col :span="14" class="hidden-text">
											<el-tooltip class="item" effect="dark" :content="item.endAddress"
												placement="top-end">
												<span>
													{{item.endAddress}}
												</span>
											</el-tooltip>
										</el-col>
									</el-row>
									<el-row class="btn-car-animation">
										<el-button type="primary" icon="el-icon-search" size="mini"
											@click.stop="clickMarkerHistory(item, index)">开始巡航</el-button>

										<el-button type="primary" icon="el-icon-search" size="mini"
											@click.stop="carMoveMarker3()">恢复</el-button>
										<el-button type="primary" icon="el-icon-search" size="mini"
											@click.stop="carMoveMarker2()">暂停</el-button>
									</el-row>
								</li>
							</ul>
						</div>
					</div>

					<div class="main">
						<amap cache-key="map" ref="map" view-mode="3D" async :zoom.sync="zoom" :center.sync="center"
							:pitch.sync="pitch" :rotation.sync="rotation" :show-indoor-map="false" is-hotspot
							@click="mapClick" @hotspotclick="onHotspotClick">
							<amap-control-bar />
							<amap-tool-bar />
							<amap-scale />
							<amap-map-type :showTraffic="false" :showRoad="false" />

							<!-- 小车轨迹和车的icon -->
							<div>
								<amap-polyline v-if="ifTrack" :path="path" :stroke-weight="7" stroke-color="#32AC2E"
									is-outline :border-weight="2" outline-color="#fff" show-dir />
								<!-- @amap-ready="onCarReady" -->
								<amap-marker v-if="car.pos" :position.sync="car.pos" :angle.sync="car.angle"
									:icon="car.icon" :offset="car.offset" ref="carMoveMarker" />
							</div>

							<div class="car-wrap">
								<div v-for="(item, index) in clusterData" :key="index" v-show="index<countA">
									<div>
										<amap-marker :position.sync="item.position" @click="clickMyVehical(item)"
											:icon="car.icon" :offset="car.offset" :anchor="anchor">
											<div>
												<div class="marker-using-slot" v-if="false">
													soc {{ item.obj.soc }}%
												</div>
												<!-- 小车暂时详细信息 -->
												<div class="detail-marker" v-if="item.ifDetailCar == false">
													<div>
														<el-row>
															<el-col :span="9">
																<el-row>
																	<el-col :span="24" class="title-l">车牌号</el-col>
																	<el-col :span="24">{{
                                  item.obj.licensePlate
                                }}</el-col>
																</el-row>
															</el-col>
															<el-col :span="8">
																<el-row>
																	<el-col :span="16" class="title-l"
																		style="text-align: center;">状态</el-col>
																	<el-col :span="24">
																		<span v-if="item.obj.engineStatus == '离线'"
																			class="statusText offline">离线</span>
																		<span v-if="item.obj.engineStatus == '行驶'"
																			class="statusText online">行驶</span>
																		<span v-if="item.obj.engineStatus == '静止'"
																			class="statusText static">静止</span>
																	</el-col>
																</el-row>
															</el-col>
															<el-col :span="7">
																<el-row>
																	<el-col :span="24" class="title-l">电池SOC:</el-col>
																	<el-col :span="12" style="color:#76DE79">
																		<span v-if="
                                      item.obj.soc < 50 && item.obj.soc >= 20
                                    " style="color:#FDDD74"><span style="font-size:18px">{{
                                      item.obj.soc
                                    }}</span>%</span>
																		<span v-if="
                                      item.obj.soc >= 0 && item.obj.soc < 20
                                    " style="color:#F97E7E"><span style="font-size:18px">{{
                                      item.obj.soc
                                    }}</span>%</span>
																		<span v-if="item.obj.soc >= 50"
																			style="color:#76DE79"><span
																				style="font-size:18px">{{
                                      item.obj.soc
                                    }}</span>%</span>
																	</el-col>
																</el-row>
															</el-col>
														</el-row>
														<el-row>
															<el-col :span="9">
																<el-row>
																	<el-col :span="24" class="title-l">车辆类型</el-col>
																	<el-col :span="24">{{
                                  item.obj.vehicleType
                                }}</el-col>
																</el-row>
															</el-col>
															<el-col :span="8">
																<el-row>
																	<el-col :span="16" class="title-l"
																		style="text-align: center;">速度</el-col>
																	<el-col :span="24">
																		{{ item.obj.speed }}km/h
																	</el-col>
																</el-row>
															</el-col>
															<el-col :span="24">
																<el-row>
																	<el-col :span="6"><span
																			style="color:rgba(0, 0, 0, 0.45);margin-right:6px">上传时间:</span>
																		<span>{{
                                    jnpf.dateFormat(item.obj.ts)
                                  }}</span>
																	</el-col>
																</el-row>
															</el-col>
														</el-row>

														<el-row>
															<el-col :span="8">当前位置:</el-col>
															<el-col :span="14" class="hidden-text">{{
                              item.obj.address
                            }}</el-col>
														</el-row>
														<el-row style="text-align:right">
															<el-button @click="showHistory(item)" type="primary"
																size="mini">查看历史轨迹</el-button>
														</el-row>
													</div>
												</div>

												<!-- 小车电量 -->
												<div v-if="item.ifDetailCar" class="detail-marker"
													style="width:120px;height:34px; position: absolute;top: -40px;left: 12px; ">
													<div>
														<el-row>
															<el-col :span="24">
																<el-row>
																	<el-col :span="6">
																		<div>
																			<img v-if="item.obj.soc >= 50"
																				src="@/assets/images/energyMuseum/cella.png"
																				alt="">
																			<img v-if="item.obj.soc < 50 && item.obj.soc >= 20"
																				src="@/assets/images/energyMuseum/cellb.png"
																				alt="">
																			<img v-if="item.obj.soc >= 0 && item.obj.soc < 20"
																				src="@/assets/images/energyMuseum/cellc.png"
																				alt="">
																			<img v-if="item.obj.soc > 100 && item.obj.soc < 0"
																				src="@/assets/images/energyMuseum/celld.png"
																				alt="">

																		</div>
																	</el-col>
																	<el-col :span="9" class="title-l">SOC</el-col>
																	<el-col :span="9"
																		style="color:#76DE79;float:right;margin-bottom:5px;">
																		<span
																			v-if="item.obj.soc < 50 && item.obj.soc >= 20"
																			style="color:#FDDD74"><span
																				style="font-size:18px">{{
                                      item.obj.soc
                                    }}</span>%</span>
																		<span
																			v-if="item.obj.soc >= 0 && item.obj.soc < 20"
																			style="color:#F97E7E"><span
																				style="font-size:18px">{{
                                      item.obj.soc
                                    }}</span>%</span>
																		<span v-if="item.obj.soc >= 50"
																			style="color:#76DE79"><span
																				style="font-size:18px">{{
                                      item.obj.soc
                                    }}</span>%</span>
																		<span
																			v-if="item.obj.soc > 100 && item.obj.soc < 0"
																			style="color:#C9C0C0"><span
																				style="font-size:18px">{{
                                      item.obj.soc
                                    }}</span>%</span>
																	</el-col>
																</el-row>
															</el-col>
														</el-row>
													</div>
												</div>

												<div>
													<div v-if="item.obj.soc < 50 && item.obj.soc >= 20">
														<el-image style="width: 28px; height: 28px"
															:src="require('@/assets/images/car/car_icon.png')"
															:fit="'fill'"></el-image>
													</div>

													<div v-if="item.obj.soc >= 0 && item.obj.soc < 20">
														<el-image style="width: 28px; height: 28px"
															:src="require('@/assets/images/car/car_icon.png')"
															:fit="'fill'"></el-image>
													</div>

													<div v-if="item.obj.soc >= 50">
														<el-image style="width: 28px; height: 28px"
															:src="require('@/assets/images/car/car_icon.png')"
															:fit="'fill'"></el-image>
													</div>
												</div>
											</div>
										</amap-marker>
									</div>
								</div>
							</div>
							<el-row :class="'baseInfo-body'" v-if="pannelShow">
								<el-col :span="24">
									<el-tabs type="border-card" :tab-position="'top'" v-model="activeName"
										@tab-click="handleClick">
										<el-tab-pane label="基本信息" name="base">
											<el-table v-loading="listLoading" :data="tableData">
												<!-- <el-table :data="tableData" style="width: 100%"> -->
												<el-table-column prop="engineStatus" label="状态" width="80">
													<template slot-scope="scope">
														<span v-if="scope.row.engineStatus == '离线'"
															class="statusText offline">离线</span>
														<span v-if="scope.row.engineStatus == '行驶'"
															class="statusText online">行驶</span>
														<span v-if="scope.row.engineStatus == '静止'"
															class="statusText static">静止</span>
													</template>
												</el-table-column>

												<el-table-column prop="licensePlate" label="车牌号码"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="soc" label="电池soc" :show-overflow-tooltip="true">
													<template slot-scope="scope">
														<span v-if="scope.row.soc < 50 && scope.row.soc >= 20"
															style="color:#FDDD74"><span style="font-size:18px">{{
                              scope.row.soc
                            }}</span>%</span>
														<span v-if="scope.row.soc >= 0 && scope.row.soc < 20"
															style="color:#F97E7E"><span style="font-size:18px">{{
                              scope.row.soc
                            }}</span>%</span>
														<span v-if="scope.row.soc >= 50" style="color:#76DE79"><span
																style="font-size:18px">{{
                              scope.row.soc
                            }}</span>%</span>
													</template>
												</el-table-column>
												<el-table-column prop="vehicleType" label="车辆类型"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="vehicleBrand" label="车辆品牌"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="gclOperatingCompany" label="运营公司"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="vin" label="车辆VIN码" width="250">
												</el-table-column>
												<el-table-column prop="realName" label="司机"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="mileage" label="累计量程"
													:show-overflow-tooltip="true">
												</el-table-column>
											</el-table>
											<el-table v-loading="listLoading" :data="tableData">
												<!-- <el-table :data="tableData" style="width: 100%"> -->

												<el-table-column prop="speed" label="速度(km/h)" width="80"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="tripmileage" label="小计量程"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="" label="续航量程" :show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="voltage" label="总电压"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="current" label="总电流"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="dcStatus" label="DC-DC状态"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="address" label="地理位置" width="250"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="mobilePhone" label="电话"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="accessTime" label="入网时间"
													:show-overflow-tooltip="true">
												</el-table-column>
											</el-table>
										</el-tab-pane>
										<!-- <el-tab-pane label="配置管理">电池信息</el-tab-pane>
          <el-tab-pane label="角色管理">换电记录</el-tab-pane> -->
										<el-tab-pane label="告警信息" name="alarm">
											<el-table :data="tableDataAlarm">
												<el-table-column prop="alarmNumber" label="告警流水号"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="alarmLevel" label="告警等级"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="alarmClassification" label="告警分类"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="alarmCoent" label="告警内容"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="timeOccurrence" label="发生时间"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="processingStatus" label="处理状态"
													:show-overflow-tooltip="true">
												</el-table-column>
												<el-table-column prop="processingResults" label="处理结果"
													:show-overflow-tooltip="true">
												</el-table-column>
											</el-table>
										</el-tab-pane>
									</el-tabs>
								</el-col>

								<!-- <el-table>

        </el-table> -->
							</el-row>
						</amap>

					</div>

					<div class="graph-wrap" style="overflow: scroll;background-color: #fff;" v-if="showGraph">
						<!-- <el-row></el-row> -->
						<!-- 图标-多车监控 -->
						<echartsMelige ref="charts1" style="width:400px;height:200px"></echartsMelige>
						<echartsSpeed ref="charts2" style="width:400px;height:200px"></echartsSpeed>
						<echartsInfo ref="charts3" style="width:400px;height:200px"></echartsInfo>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { dataInterface } from '@/api/dataInterfaceApi'
	import { multiCarMonitorApi } from '@/api/multiCarMonitorApi'

	import echartsMelige from "./multiCarMonitor/echartsMelige.vue";
	import echartsInfo from "./multiCarMonitor/echartsInfo.vue";
	import echartsSpeed from "./multiCarMonitor/echartsSpeed.vue"
	import addrescopy from './multiCarMonitor/address.vue'
	// 地图
	// 函数api
	import { loadAmap, loadPlugins } from "@amap/amap-vue";
	// import {carIcon} from ;
	function interpolate(u, begin, end) {
		if (u < 0) u = 0;
		if (u > 1) u = 1;
		u = Math.pow(u, 1 / 10);
		return u * (end - begin) + begin;
	}
	const path = Object.freeze(require("./multiCarMonitor/pa.json"));

	export default {
		components: {
			echartsMelige,
			echartsSpeed,
			echartsInfo,
			addrescopy
		},
		data() {
			const dx = path[1][0] - path[0][0];
			const dy = path[1][1] - path[0][1];

			return {
				kmNum: 0, // 里程范围
				kmNumCopy: 0,
				chaCity: '', // 经纬度城市
				// 经纬度范围
				longitudeLatitude: [{
						city: '广东省东莞市',
						longitudeStart: '113.31',
						longitudeEnd: '114.15 ',
						latitudeStart: '22.39',
						latitudeEnd: '23.09'
					},
					{
						city: '北京市市辖区',
						longitudeStart: '115.70',
						longitudeEnd: '117.40',
						latitudeStart: '39.40',
						latitudeEnd: '41.60'
					},
					{
						city: '北京市县',
						longitudeStart: '115.70',
						longitudeEnd: '117.40',
						latitudeStart: '39.40',
						latitudeEnd: '41.60'
					},
					{
						city: '天津市市辖区',
						longitudeStart: '116.43',
						longitudeEnd: '118.04',
						latitudeStart: '38.34',
						latitudeEnd: '40.15'
					},
					{
						city: '天津市市辖县',
						longitudeStart: '116.43',
						longitudeEnd: '118.04',
						latitudeStart: '38.34',
						latitudeEnd: '40.15'
					},
					{
						city: '河北省秦皇岛市',
						longitudeStart: '118.33',
						longitudeEnd: '119.51',
						latitudeStart: '39.24',
						latitudeEnd: '40.37'
					},
					{
						city: '河北省邯郸市',
						longitudeStart: '114.03',
						longitudeEnd: '114.40',
						latitudeStart: '36.20',
						latitudeEnd: '36.44'
					},
					{
						city: '河北省邢台市',
						longitudeStart: '113.52',
						longitudeEnd: '115.49',
						latitudeStart: '36.50',
						latitudeEnd: '37.47'
					},
					{
						city: '山西长治市',
						longitudeStart: '111.59',
						longitudeEnd: '113.44',
						latitudeStart: '35.49',
						latitudeEnd: '37.07'
					},
					{
						city: '山西晋城市',
						longitudeStart: '111.55',
						longitudeEnd: '113.70',
						latitudeStart: '35.11',
						latitudeEnd: '36.04'
					},
					{
						city: '湖北省荆州市',
						longitudeStart: '111.15',
						longitudeEnd: '114.05',
						latitudeStart: '29.26',
						latitudeEnd: '31.37'
					},
					{
						city: '新疆维吾尔自治区乌鲁木齐市',
						longitudeStart: '86.3733',
						longitudeEnd: '88.5824 ',
						latitudeStart: '42.4532',
						latitudeEnd: '45.0000'
					},
					{
						city: '湖南省长沙市',
						longitudeStart: '111.53',
						longitudeEnd: '114.15',
						latitudeStart: '27.51',
						latitudeEnd: '28.41'
					},
					{
						city: '湖南省衡阳市',
						longitudeStart: '110.3216',
						longitudeEnd: '113.1632',
						latitudeStart: '26.0705',
						latitudeEnd: '27.2724'
					},
					{
						city: '江苏省无锡市',
						longitudeStart: '119.33',
						longitudeEnd: '120.38',
						latitudeStart: '31.07',
						latitudeEnd: '32.02'
					},
					{
						city: '江苏省徐州市',
						longitudeStart: '116.358',
						longitudeEnd: '118.667',
						latitudeStart: '33.717',
						latitudeEnd: '34.976'
					},
					{
						city: '江苏省苏州市',
						longitudeStart: '119.55',
						longitudeEnd: '121.20',
						latitudeStart: '30.47',
						latitudeEnd: '32.02'
					},
				],
				optionsCity: [],
				past: true,
				noMoreA: false,
				countA: 0,
				// listDatasCopy: [],
				loadingA: false,
				carDetail: true,
				ifTrack: true,
				graphData: {
					xuData: true,
					gjName: "轨迹4",
					startDate: "2021-10-28 12:15:00",
					endDate: "2021-10-28 12:25:00",
					longitude1: "151.39",
					latitude1: "33.91",
					latitudetype1: "NORTH",
					longitudetype1: "EAST",
					longitude2: "153.39",
					latitude2: "35.91",
					latitudetype2: "NORTH",
					longitudetype2: "EAST",
					lnglat: "[[151.39,33.91],[152.39,34.91],[153.39,35.91]]",
					longitudeAll: null,
					latitudeAll: null,
					mileageAll: "1204353.0,1204363.0,1204373.0", // 累计里程
					speedAll: "6563,6566,6576", // 车速
					socAll: "91,92,93", // soc
					cellMaxVoltageAll: "221,229,232",
					cellMinVoltageAll: "212,222,227",
					maxTemperatureAll: "22,24,27",
					minTemperatureAll: "12,16,18",
					dateAll: "2021-10-28 12:15:00,2021-10-28 12:20:00,2021-10-28 12:25:00"
				},
				listDatasHistory: [],
				pickerVal: [],
				clusterShow: false,
				pannelShow: false,
				listDatas: [],
				alarmNum: "",
				provinces: ["32", "3203"], //["32", "3203"]
				// 2:熄火、3:其他状态、3:异常、5:无效
				stationOptions: [{
						id: "1",
						fullName: "行驶"
					},
					{
						id: "-1",
						fullName: "离线"
					},
					{
						id: "0",
						fullName: "静止"
					},
					{
						id: "2",
						fullName: "熄火"
					},
					{
						id: "3",
						fullName: "其他状态"
					},
					{
						id: "4",
						fullName: "异常"
					},
					{
						id: "5",
						fullName: "无效"
					},
				],
				showAll: false,
				query: {
					licensePlate: "", // 车牌号
					// vehicleVin: "MQTTT0P1C", // vin码
					vehicleVin: "", // LC1HNYBJ4L0016376
					startDate: "", // 开始时间
					endDate: "", // 结束时间
					dataType: "0", // 1请求告警
					alarmEquipmentCode: undefined,
					isCreate: undefined,
					stationId: undefined,
					alarmCode: undefined,
					occurStartTime: undefined,
					occurEndTime: undefined,
					processingStatus: undefined,


					vehicleBrand: undefined, // 车辆品牌
					vehicleModel: undefined, // 车辆型号

					// alarmEventClassification:"0"
				},

				defaultProps: {
					children: "children",
					label: "fullName"
				},
				list: [],
				listLoading: true,
				total: 0,
				listQuery: {
					currentPage: 1,
					sidx: ""
				},
				formVisible: false,
				alarmHandleFormVisible: false,
				exportBoxVisible: false,
				columnList: [
				],
				// isCreateOptions: [
				//   { fullName: "是", id: "1" },
				//   { fullName: "否", id: "2" },
				// ],
				// occurTime: [],
				pickerOptions: {
					shortcuts: [{
							text: "最近一周",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit("pick", [start, end]);
							}
						},
						{
							text: "最近一个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit("pick", [start, end]);
							}
						},
						{
							text: "最近三个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit("pick", [start, end]);
							}
						}
					]
				},
				stationIdOptions: [],
				channelNumberOptions: [],
				processingStatusOptions: [],


				vehicleBrandOptions: [],
				vehicleBrandProps: {
					children: "children",
					multiple: false,
					label: "fullName",
					value: "id",
				},
				// vehicleModelOptions: [],

				// 地图的功能
				show: false,
				elec_num: 20,
				tag: "base",
				pos2: [116.493671, 39.993083],
				tableData: [],
				tableDataAlarm: [],
				activeName: "base",
				path, // 小车轨迹点
				car: {
					// path[0].slice(0)
					// pos: path[0].slice(0), // 小车icon的坐标，为空不能设置该key.
					angle: (Math.atan2(dy, dx) * 180) / Math.PI,
					icon: {
						image: "https://jimnox.gitee.io/amap-vue/assets/car.png",
						imageSize: [26, 50]
					},

					offset: [-13, -25]
				}, // 历史轨迹小车图标

				options: {
					gridSize: 80,
					averageCenter: true,
					styles: Object.freeze([{
							url: "https://jimnox.gitee.io/amap-vue/assets/clusters/blue.png",
							size: [32, 32],
							offset: [-16, -16]
						},
						{
							url: "https://jimnox.gitee.io/amap-vue/assets/clusters/green.png",
							size: [32, 32],
							offset: [-16, -16]
						},
						{
							url: "https://jimnox.gitee.io/amap-vue/assets/clusters/orange.png",
							size: [36, 36],
							offset: [-18, -18]
						},
						{
							url: "https://jimnox.gitee.io/amap-vue/assets/clusters/red.png",
							size: [48, 48],
							offset: [-24, -24]
						},
						{
							url: "https://jimnox.gitee.io/amap-vue/assets/clusters/darkRed.png",
							size: [48, 48],
							offset: [-24, -24]
						}
					])
				}, // 特殊得option样图

				data: [
					// { lnglat: ["101.985037", "23.15046"]  },
					// { lnglat: ["103.939621", "21.343147"]   },
					// { lnglat: ["101.985037", "23.15046"] ,'desc':'121'},
					// { lnglat: ["109.939621", "20.343147"] ,'desc':'124' },
				], // 首页集合点得经纬度数据,点聚合，和热力图数据使用

				// center: [116.473778, 39.990661],
				center: [116.473571, 39.993083],
				position: [116.473778, 39.990661],
				zoom: 5, // 缩放比例 14是放大后精度，5是初始精度
				historyPage: false, // 历史轨迹页面
				pitch: 0, // 倾斜
				rotation: 15, // 旋转
				AMap: null,
				cluster: null, // 集合点对象
				active: 0,
				carOptions: [], // 查询字典数组
				city: "", // 现在城市
				lngMap: {}, // 对象映射
				clusterData: [], // 车标记对象
				anchor: "center",
				chooseVin: "",
				showGraph: false,
				carData: {
					ts: "",
					vin: ""
				}, // 小车在左侧列表点击后生成
				nowCarPosition: [],
				timer: null,
				chooseIndex: -1,
				chooseIndex2: -1,
				icon1: {
					image: "@/assets/images/car/icon1.png",
					imageSize: [26, 50]
				},
				icon2: {
					image: "@/assets/images/car/icon2.png",
					imageSize: [26, 50]
				},
				icon3: {
					image: "@/assets/images/car/icon3.png",
					imageSize: [26, 50]
				},
				icon4: {
					image: "@/assets/images/car/icon4.png",
					imageSize: [26, 50]
				},
				loading: false,
				// 多车监控轨迹
				dataArr: [],
				dataTime: [], // 时间
				mileageAllA: [], // 累计里程
				socAllA: [], //SOC
				speedAllA: [], // 车速
				maxTemperatureAllA: [], //最高温度
				minTemperatureAllA: [], //最低温度
				cellMaxVoltageAllA: [], //最高电压
				cellMinVoltageAllA: [], //最低电压
			};
		},
		computed: {
			noMore() {
				// console.log('执行1')
				return this.countA >= 2000
			},
			disabled() {
				// console.log('执行2')
				return this.loadingA || this.noMore
			}
		},
		watch: {
			provinces: {
				handler(a, b) {
					if (a) {
						console.log('所在城市', a)
						const xu = a[0] + a[1]
						if (xu == '323203') {
							this.xuData = true
							const this_ = this
							setTimeout(() => {
								this_.search()
							}, 1000)
							console.log('执行1', this.xuData)
						} else {
							this.xuData = false
							const this_ = this
							setTimeout(() => {
								this_.search()
							}, 1000)
							console.log('执行2', this.xuData)
						}
					}
				},
				deep: true,
				immediate: true
			},
			car: {
				handler(a, b) {
					this.dataArr.push(a)
					console.log('监听数组', a)
					this.dataTime = []
					this.mileageAllA = []
					this.socAllA = []
					this.speedAllA = []
					this.maxTemperatureAllA = []
					this.minTemperatureAllA = []
					this.cellMaxVoltageAllA = []
					this.cellMinVoltageAllA = []
					for (var i = 0; i < this.dataArr.length; i++) {
						this.dataArr[i].item.dateAllCopy = this.dataArr[i].item.dateAll.split(',')
						this.dataTime.push(this.dataArr[i].item.dateAllCopy[i])
						// console.log('时间', this.dataTime.join(','))
						this.dataArr[i].item.mileageAllCopy = this.dataArr[i].item.mileageAll.split(',')
						this.mileageAllA.push(this.dataArr[i].item.mileageAllCopy[i])
						// console.log('累计里程', this.mileageAllA.join(','))
						this.dataArr[i].item.socAllCopy = this.dataArr[i].item.socAll.split(',')
						this.socAllA.push(this.dataArr[i].item.socAllCopy[i])
						// console.log('soc', this.socAllA.join(','))
						this.dataArr[i].item.speedAllCopy = this.dataArr[i].item.speedAll.split(',')
						this.speedAllA.push(this.dataArr[i].item.speedAllCopy[i])
						// console.log('车速', this.speedAllA.join(','))
						this.dataArr[i].item.maxTemperatureAllCopy = this.dataArr[i].item.maxTemperatureAll.split(',')
						this.maxTemperatureAllA.push(this.dataArr[i].item.maxTemperatureAllCopy[i])
						// console.log('最高温度', this.maxTemperatureAllA.join(','))
						this.dataArr[i].item.minTemperatureAllCopy = this.dataArr[i].item.minTemperatureAll.split(',')
						this.minTemperatureAllA.push(this.dataArr[i].item.minTemperatureAllCopy[i])
						// console.log('最低温度', this.minTemperatureAllA.join(','))
						this.dataArr[i].item.cellMaxVoltageAllCopy = this.dataArr[i].item.cellMaxVoltageAll.split(',')
						this.cellMaxVoltageAllA.push(this.dataArr[i].item.cellMaxVoltageAllCopy[i])
						// console.log('最高电压', this.cellMaxVoltageAllA.join(','))
						this.dataArr[i].item.cellMinVoltageAllCopy = this.dataArr[i].item.cellMinVoltageAll.split(',')
						this.cellMinVoltageAllA.push(this.dataArr[i].item.cellMinVoltageAllCopy[i])
						// console.log('最低电压', this.cellMinVoltageAllA.join(','))
						let data = {
							dateAll: this.dataTime.join(','),
							mileageAll: this.mileageAllA.join(','),
							socAll: this.socAllA.join(','),
							speedAll: this.speedAllA.join(','),
							maxTemperatureAll: this.maxTemperatureAllA.join(','),
							minTemperatureAll: this.minTemperatureAllA.join(','),
							cellMaxVoltageAll: this.cellMaxVoltageAllA.join(','),
							cellMinVoltageAll: this.cellMinVoltageAllA.join(','),
						}
						this.$nextTick(() => {
							// console.log('data里面的数据', data)
							this.$refs.charts1.initData(data);
							this.$refs.charts2.initData(data);
							this.$refs.charts3.initData(data);
						});
					}
				},
				deep: true
			}
		},
		created() {
			// this.initData();

			this.getvehicleBrandOptions();
			// this.getvehicleModelOptions();

			// this.getstationIdOptions();
			// this.getprocessingStatusOptions();
		},
		async mounted() {
			this.AMap = await loadAmap();
            // debugger
			clearInterval(this.timer);
			// 数据字典

			dataInterface.getDictionaryDataSelector("54642f0c50c041b5b9760a979c31a77c").then(res => {
				this.carOptions = res?.data?.list || []
			});
			// 初始化查询时间
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			this.query.startDate = start;
			this.query.endDate = end
			this.pickerVal = [start, end]
			// this.search()
			this.onCityChangeCopy()
			this.provincesList()
		},
		destroyed() {
			clearInterval(this.timer);
			this.timer = null;
		},

		methods: {
			// 省市区
			provincesList() {
				dataInterface.provincesList().then(res => {
					this.optionsCity = res.data
				})
			},
			onSin() {
				// 地图上标注车辆
				setTimeout(() => {
					if (this.data) {
						for (var i = 0; i < this.listDatas.length; i++) {
							let pos = [Number(this.listDatas[i].lnglat[0]), Number(this.listDatas[i].lnglat[1])]
							this.listDatas[i].position = pos
							this.listDatas[i].obj = this.listDatas[i]
							this.listDatas[i].ifDetailCar = true
						}
						this.clusterData = this.listDatas

					}
				}, 1500)
			},
			loadA() {
				// 分页加载数据
				this.listDatas = this.listDatas
				this.loadingA = true
				this.noMoreA = false
				setTimeout(() => {
					if (this.countA >= this.listDatas.length) {
						this.noMoreA = true
					}
					this.countA += 5
					this.loadingA = false
				}, 500)
			},
			// 返回
			manyCarMonitorBack() {
				const view = {
					fullPath: "/extend/viewalarminfo/multiCarMonitor",
					hash: "",
					name: "vehiclemonitoring",
					path: "/extend/viewalarminfo/multiCarMonitor",
					title: "vehiclemonitoring",
					zhTitle: "多车监控管理"
				}
				this.$store.dispatch('tagsView/delCachedView', view).then(() => {
					let {
						fullPath
					} = view
					// 对外链刷新的处理，：需要转义
					if (fullPath.indexOf(':') > -1) {
						fullPath = fullPath.replace('/', '')
						fullPath = '/' + encodeURIComponent(fullPath)
					}
					this.$nextTick(() => {
						this.$router.replace({
							path: '/redirect' + fullPath
						})
					})
				})
			},
			getvehicleBrandOptions() {
				dataInterface.getDictionaryDataSelector("4bad0f4658c0461283ba1e4dcacd11fe").then(
					(res) => {
						this.vehicleBrandOptions = res?.data?.list || []
					}
				);
			},
			// getvehicleModelOptions() {
			// 	previewDataInterface("e7e1830a775b4dea8abe71859083f577").then((res) => {
			// 		this.vehicleModelOptions = res.data;
			// 	});
			// },

			computedCarColor(item) {
				console.log(item, "2");
				if (item.obj.soc < 50 && item.obj.soc >= 20) {
					console.log("11", this.icon2);
					return this.icon2;
				} else if (item.obj.soc >= 0 && item.obj.soc < 20) {
					console.log("12", this.icon4);
					return this.icon4;
				} else if (item.obj.soc >= 50) {
					console.log("13", this.icon1);
					return {
						image: "/public/images/icon1.png",
						imageSize: [26, 50]
					};
				} else {
					return this.icon3;
				}
			},
			clickMarkerHistory(item, index) {
				this.dataArr = []
				// this.dataTime = []
				// this.mileageAllA = []
				console.log('执行吗！！', item)
				this.chooseIndex2 = index;
				// 绘制车轨迹
				let arr = JSON.parse(item.lnglat);
				this.path = arr;

				// 放大地图比例,设置中心点，设置起始车icon坐标
				this.zoom = 14;
				this.center = this.path[0];

				this.car.pos = this.path[0].slice(0);
				this.car.item = item

				// 展示图表
				console.log(item);
				this.showGraph = true;
				this.initGrah(item);

				setTimeout(async () => {
					this.car.pos = this.path[0].slice(0);
					await loadPlugins("AMap.MoveAnimation");
					this.$refs["carMoveMarker"].$target.moveAlong(this.path, {
						speed: 2000,
						circlable: false,
						autoRotation: true
					});
					clearInterval(this.timer);
					this.timer = setInterval(() => {
						if (this.car.pos == this.center || !this.car.pos) {
							console.log("clearinterval");
							clearInterval(this.timer);
						} else {
							this.center = this.car.pos;
						}
					}, 3000);
				}, 500);
			},
			// 小车移动
			async onCarReady(car) {
				console.log("carready");
				// await loadPlugins("AMap.MoveAnimation");
				// car.moveAlong(path, {
				//   speed: 2000,
				//   circlable: true,
				//   autoRotation: true,
				// });
			},
			async carMoveMarker1(item, index) {
				if (this.zoom != 14) {
					this.clickMarkerHistory(item, index);
				}
				await loadPlugins("AMap.MoveAnimation");
				this.$refs["carMoveMarker"].$target.moveAlong(this.path, {
					speed: 2000,
					circlable: false,
					autoRotation: true
				});

				clearInterval(this.timer);
				this.timer = setInterval(() => {
					if (this.car.pos == this.center || !this.car.pos) {
						console.log("clearinterval");
						clearInterval(this.timer);
					} else {
						this.center = this.car.pos;
					}
				}, 3000);
			},
			async carMoveMarker2() {
				await loadPlugins("AMap.MoveAnimation");
				console.log(this.$refs["carMoveMarker"].$target);
				this.$refs["carMoveMarker"].$target.stopMove();

				this.center = this.car.pos;
			},
			async carMoveMarker3() {
				await loadPlugins("AMap.MoveAnimation");
				this.$refs["carMoveMarker"].$target.resumeMove();
			},
			// 左侧的列表li点击
			onHistoryListClick() {},
			async showHistoryList(data) {
				let arr = [];
				let city = this.city ? this.city : "";
				for (let index = 0; index < data.length; index++) {
					let element = data[index];
					let lng1 = [element.longitude1, element.latitude1]; // 起点经纬度
					let lng2 = [element.longitude2, element.latitude2]; // 终点经纬度
					let startAddress = "";
					let endAddress = "";

					element.startAddress = await this.getAddress(city, lng1);
					element.endAddress = await this.getAddress(city, lng2);
					arr.push(element);
				}
				this.kmNum = this.kmNumCopy
				this.loading = false
				this.listDatasHistory = arr;
			},
			showHistory(e) {
				this.past = false
				this.pannelShow = false;
				console.log(e, "history");
				// 展示新的查询条件
				this.historyPage = true;
				this.query.vehicleVin = e.obj.vin;
				// 先默认用这个有数据的。
				// this.query.vehicleVin = "MQTTT0P1C";
				this.query.licensePlate = e.obj.licensePlate;
				this.clusterData = [];
				this.$nextTick(() => {
					this.search()
				})
			},
			// 进去页面默认查询江苏徐州
			onCityChangeCopy() {
				this.$nextTick(() => {
					let city = '江苏省徐州市';
					this.initLocation(city);
					this.zoom = 11;
					this.city = city;
				});
			},
			// 切换所在城市
			onCityChange(e) {
				console.log('eeeeeeeeeeeeeee', e)
				var cityC = this.$refs['addressCopy'].getCheckedNodes()[0].pathLabels[0] + this.$refs['addressCopy']
					.getCheckedNodes()[0].pathLabels[1]
				this.chaCity = cityC
				console.log('rrrrrrrrrrrrrrr', cityC)
				this.$nextTick(() => {
					this.initLocation(cityC);
					this.zoom = 11;
					this.city = cityC;
				});
			},
			// // 数据接口站点信息
			// getstationIdOptions() {
			// 	previewDataInterface("a5a81c1877fa48e4bb9c68765ca43b2f").then(res => {
			// 		this.stationIdOptions = res.data;
			// 	});
			// },
			// // 数据接口处理状态
			// getprocessingStatusOptions() {
			// 	dataInterface.getDictionaryDataSelector("7ac1297568814cfe8f092e182dfacd69").then(
			// 		res => {
			// 			this.processingStatusOptions = res.data.list;
			// 		}
			// 	);
			// },
			load() {
				console.log("加载");
			},
			// 查询全部车辆 / 轨迹数据
			initData() {
				this.listDatas = []
				this.clusterData = []
				this.listLoading = true;
				let _query = {
					...this.listQuery,
					...this.query
				};
				let query = {};
				for (let key in _query) {
					if (Array.isArray(_query[key])) {
						query[key] = _query[key].join();
					} else {
						query[key] = _query[key];
					}
				}
				// 如果在详情页面请求历史轨迹
				this.loading = true
				this.$nextTick(() => {
					// 获取历史轨迹
					if (this.historyPage) {
						if (!query.startDate || !query.endDate) {
							this.$message({
								message: "时间未选择",
								type: "warning"
							});
							return;
						}

						//   request({
						//     url: `/api/vehiclescheduling/GclVehicleMonitor/historyData`,
						//     method: "get",
						//     data: query
						//   })
						multiCarMonitorApi.historyData(query).then(res => {
							console.log(res, "历史轨迹1");
							if (res?.data?.list.length) {
								this.kmNumCopy = res.data.totalMileage
								this.showHistoryList(res.data.list);
							} else {
								this.$message({
									message: "暂无数据",
									type: "success"
								});
								this.loading = false
								this.listDatas = []
							}
						}).catch(e => {
							this.loading = false
						});

					} else {
						// 获取全部车辆数据接口
						if (this.provinces.length != 0) {
							var citData = {
								longitudeStart: '116.358',
								longitudeEnd: '118.667',
								latitudeStart: '33.717',
								latitudeEnd: '34.976',
							}
						} else {
							var citData = {
								longitudeStart: null,
								longitudeEnd: null,
								latitudeStart: null,
								latitudeEnd: null,
							}
							this.chaCity = null
						}
						for (var t = 0; t < this.longitudeLatitude.length; t++) {
							if (this.chaCity == this.longitudeLatitude[t].city) {
								citData = this.longitudeLatitude[t]
							}
						}
						query.longitudeStart = citData.longitudeStart
						query.longitudeEnd = citData.longitudeEnd
						query.latitudeStart = citData.latitudeStart
						query.latitudeEnd = citData.latitudeEnd
						console.log('查询传的值', query)
						//   request({
						//     url: `/api/vehiclescheduling/GclVehicleMonitor`,
						//     method: "get",
						//     data: query
						//   })
                        console.log('multiCarMonitorApi.gclVehicleMonitor', multiCarMonitorApi.gclVehicleMonitor)
						multiCarMonitorApi.gclVehicleMonitor(query).then(async res => {
							this.loading = true
							let arr = res.data[0];
							// 左侧列表
							let listDatas = [];
							let lngMap = {};
							let count = 0;
							this.lngMap = {};
							this.data = [];
							this.listDatas = [];
							this.clusterShow = false;
							console.log('准备循环前的数据长度', arr.length)
							var arrCopy = []
							for (let index = 0; index < arr.length; index++) {
								let element = arr[index];
								let lng = [element.longitude, element.latitude];
								let city = this.city ? this.city : "";
								let key = element.longitude + "-" + element.latitude;
								this.getAddress(city, lng)
									.then(res => {
										// console.log('执行几次', res)
										element.address = res;
										arrCopy.push(element);

										this.lngMap[key] = element;
										console.log('可以拿到数据吗~~~', arrCopy.length)
										if (arrCopy.length == arr.length) {
											console.log('执行几次')
											for (var iLi = 0; iLi < arrCopy.length; iLi++) {
												if (arrCopy[iLi].engineStatus == '离线') {
													arrCopy[iLi].engineStatusNum = 1
												} else if (arrCopy[iLi].engineStatus == '行驶') {
													arrCopy[iLi].engineStatusNum = 3
												} else if (arrCopy[iLi].engineStatus == '静止') {
													arrCopy[iLi].engineStatusNum = 2
												}
											}
											arrCopy.sort(function(a, b) {
												return b.engineStatusNum - a
													.engineStatusNum;
											})
											this.listDatas = arrCopy
											this.loading = false
											this.countA = 10
											console.log('排序之后的数据', arrCopy)
										}
									})
									.catch(err => {});

								// 通过车辆状态排序
							}

							if (this.active == 0) {
								this.total = Object.keys(this.lngMap).length;
							} else if (this.active == 1) {
								// this.total = 0;
								this.alarmNum = Object.keys(this.lngMap).length;
							}

							// 点聚合数据，热力图数据
							this.data = res.data[1];
							this.clusterShow = true;
							console.log(this.data, "点聚合数据");

							this.listLoading = false;
							this.loading = false
							this.onSin()
						}).catch(e => {
							this.loading = false
						});
					}
				})
			},

			search() {
				// this.listQuery = {
				//   currentPage: 1,
				//   pageSize: 20,
				//   sort: "desc",
				//   sidx: "alarmNumber",
				// };
				this.pannelShow = false
				if (this.pickerVal && this.pickerVal.length) {
					this.query.startDate = this.pickerVal[0];
					this.query.endDate = this.pickerVal[1];
				} else {
					this.query.startDate = null;
					this.query.endDate = null;
				}
				this.initData();
			},

			refresh(isrRefresh) {
				this.formVisible = false;
				this.alarmHandleFormVisible = false;
				if (isrRefresh) {
					this.initData();

					this.zoom = 5;
				}
			},
			initGrah(data) {
				if (data) {
					this.graphData = data;
				}
				// this.$nextTick(() => {
				//   console.log('这里data传了什么数据', data)
				//   this.$refs.charts1.initData(data);
				//   this.$refs.charts2.initData(data);
				//   this.$refs.charts3.initData(data);
				// });
			},
			reset() {
				this.listQuery = {
					currentPage: 1,
					pageSize: 20,
					sort: "desc",
					sidx: ""
				};
				this.zoom = 5;
				// 清空
				this.clusterData = [];
				this.clusterShow = false;
				this.historyPage = false;
				this.initData();
			},
			handleClick(e) {
				this.tag = e.label;
				console.log(e);
				// 如果是告警请求告警信息
				if (e.label == "告警信息")
					switch (e.label) {
						case "告警信息":
							if (this.tableDataAlarm.length <= 0) {
								// 请求告警信息
								//   request({
								//     url: `/api/vehiclescheduling/GclVehicleMonitor/getVehicleInfoByWarn/${this.chooseVin}`,
								//     method: "get"
								//   })
								multiCarMonitorApi.getVehicleInfoByWarn(this.chooseVin).then(res => {
									console.log(res, "告警信息");

									// let table = res.data
									// // table.address = e.address;

									this.tableDataAlarm = res.data;
								});
							}
							break;
						case "基本信息":
							break;
					}
			},
			// 更换列表
			changeActive(active) {
				this.active = active;
				this.query.dataType = active;
				this.initData();
			},
			// 小车点击事件
			clickMyVehical(e) {
				console.log(e, "小车点击事件");
				e.ifDetailCar = !e.ifDetailCar
				// if(!e.vin){
				//   e.vin  = this.carData.vin;
				//   e.ts = this.cardData.ts
				// }
				this.showPannel(e.obj);

				this.pannelShow = true;
			},
			// 获取地址信息数据
			getAddress(city = "", location) {
				// city, location  对应的省市区 以及车辆坐标
				return new Promise((resolve, reject) => {
					let geocoder = new this.AMap.Geocoder({
						city: city //默认：“全国”
					});
					geocoder.getAddress(location, (status, result) => {
						// status, result 获取小车在地图上展示的详细地址
						if (status === "complete" && result.info === "OK") {
							// let province = result.regeocode.addressComponent.province;
							// let city = result.regeocode.addressComponent.city;
							let wholeAddress = result.regeocode.formattedAddress;
							// wholeAddress = wholeAddress.replace(province, "");
							// wholeAddress = wholeAddress.replace(city, "");
							resolve(wholeAddress);
						} else {
							resolve("解析地址失败");
						}
					});
				});
			},

			listCardChange(e) {
				// 列表类型切换
				console.log(e);
			},
			clickMarkerCopy() {
				const event = JSON.parse(localStorage.getItem('monitoring')).event
				const index = JSON.parse(localStorage.getItem('monitoring')).index
			},
			clickMarker(event, index) {
				this.pannelShow = false
				console.log('@@@', event, index)
				const data_ = {
					event: event,
					index: index
				}
				console.log('dddddddddddddddd', data_)
				// localStorage.setItem("monitoring", JSON.stringify(data_));
				// 左侧列表点击事件
				// 设置选中状态
				this.chooseIndex = index;
				console.log(this.chooseIndex, index);
				// this.$set(this.listDatas ,index, event)
				let clusterData = [event].map(item => {
					// debugger
					// let lngs = item.lnglat;
					let position = [item.longitude, item.latitude];
					let key = position.join("-");
					let obj = this.lngMap[key];
					let re = {};
					let style = "position:absolute;z-index:99";
					re.position = position;
					re.obj = obj;
					re.style = style;
					re.show = false;
					return re;
				});

				this.clusterData = clusterData;
				// 显示车标记，取消点聚合，增大缩放比例
				this.zoom = 12;
				this.clusterShow = false;
				this.center = this.clusterData[0].position;
				this.showPannel(event);
				// 需要设置好vin 和ts,因为对应的小车点击事件在聚合点和列表点击的车实际上是两个事件。
				this.carData.ts = event.ts;
				this.carData.vin = event.vin;

				this.clusterData[0].ifDetailCar = true
				console.log(this.clusterData[0], "单点标记");
			},
			showPannel(e) {
				// 信息面板打开

				// 请求数据
				// request({
				// 	url: `/api/vehiclescheduling/GclVehicleMonitor/getVehicleInfo/${e.ts}/${e.vin}`,
				// 	method: "get"
				// })
                multiCarMonitorApi.getVehicleInfo(e).then(res => {
					console.log(res, "基本信息");
					let table = res.data;
					table.address = e.address;
					this.chooseVin = table.vin;
					this.tableData = [{
						...table
					}];
				});
			},
			getMarkerOptions() {
				return {
					// position: point.lnglat,
					offset: [-15, -15]
					// content: '<div class="custom-marker" />',
				};
			},
			getClusterOptions(context) {
				const size = Math.round(
					30 + Math.pow(context.count / this.data.length, 1 / 5) * 20
				);
				return {
					offset: [-size / 2, -size / 2]
				};
			},
			getMarkerStyle() {
				// const u = point.count / this.data.length;
				// console.log(point)
				// const hue = ~~interpolate(u, 90, 0);
				// const size = ~~interpolate(u, 30, 50);
				const size = 20;
				return {
					backgroundColor: `rgba(3, 153, 9, 100)`,
					width: `${size}px`,
					height: `${size}px`,
					lineHeight: `${size}px`,
					borderRadius: `${size / 2}px`,
					border: `rgba(255, 255, 255, 100)`,
					// boxShadow: `0 0 1px hsla(${hue}, 100%, 50%, 1)`,
					color: `white`,
					fontSize: "12px",
					textAlign: "center"
				};
			},
			getClusterStyle(context) {
				const u = context.count / this.data.length;
				const hue = ~~interpolate(u, 90, 0);
				const size = ~~interpolate(u, 30, 50);
				return {
					backgroundColor: `hsla(${hue}, 100%, 50%, 0.7)`,
					width: `${size}px`,
					height: `${size}px`,
					lineHeight: `${size}px`,
					borderRadius: `${size / 2}px`,
					border: `1px solid hsla(${hue}, 100%, 40%, 1)`,
					boxShadow: `0 0 1px hsla(${hue}, 100%, 50%, 1)`,
					color: `hsla(${hue}, 100%, 20%, 1)`,
					fontSize: "14px",
					textAlign: "center"
				};
			},
			initLocation(city = "", address) {
				let geocoder = new this.AMap.Geocoder({
					city: city //默认：“全国”
				});

				address = address ? city + address : city;
				geocoder.getLocation(address, (status, result) => {
					if (status === "complete" && result.geocodes.length) {
						let lnglat = result.geocodes[0].location;
						this.position = [lnglat.lng, lnglat.lat];
						this.center = [lnglat.lng, lnglat.lat];
						// 坐标更新事件
					} else {
						console.log("根据地址查询位置失败");
						// 失败提示事件
					}
				});
			},
			mapClick(e) {
				console.log('这里是点击什么啊', this.clusterData)
				for (var i = 0; i < this.clusterData.length; i++) {
					this.clusterData[i].ifDetailCar = true
				}
				if (this.pannelShow) {
					this.pannelShow = false;
					return;
				}
				if (e && e.lnglat) {
					this.position = [e.lnglat.lng, e.lnglat.lat];
					this.center = [e.lnglat.lng, e.lnglat.lat];
				}
				// 坐标更新事件
			},
			onHotspotClick(e) {
				if (e && e.lnglat) {
					this.center = [e.lnglat.lng, e.lnglat.lat];
				}
			}
		}
	};
</script>

<style scope lang="scss">
	li.bge5 {
		background-color: #e5e5e5;
	}
</style>

<style lang="scss" scoped>
    .JNPF-common-layout {
        height: 100%;
        .JNPF-common-layout-center {
            height: 100%;
            display: flex;
            flex-direction: column;
            .JNPF-common-layout-main {
                flex: 1;
            }
        }
    }
	.baseInfo-body {
		position: absolute;
		/* bottom: 327px;
  left:262px; */
		/* bottom: 10px;
  left: 253px; */
		width: 100%;
		bottom: 0px;
		/* left: 310px; */
		z-index: 999;
	}

	/* .baseInfo-body2{
  position: relative;
  top: 423px;
  left:252px;
  z-index:999;
} */
	.detail-marker {
		position: absolute;
		top: -244px;
		left: 26px;
		width: 235px;
		border-radius: 5px;
		white-space: nowrap;
		padding: 0 10px;
		background-color: rgba(255, 255, 255, 0.2);
		background-color: rgba(255, 255, 255, 100);
		color: rgba(16, 16, 16, 100);
		font-size: 14px;
		/* text-align: center; */
		box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
		font-family: Roboto;
		border: 1px solid rgba(255, 255, 255, 100);
	}

	.detail-marker .el-row {
		padding: 4px 2px;
	}

	.no-data {
		text-align: center;
		font-size: 15px;
		padding: 8px;
	}

	.marker-using-slot {
		position: absolute;
		top: -28px;
		left: -28px;
		border-radius: 3px;
		white-space: nowrap;
		padding: 0 10px;
		background-color: rgba(255, 255, 255, 0.2);
		background-color: rgba(255, 255, 255, 100);
		color: rgba(16, 16, 16, 100);
		font-size: 14px;
		text-align: center;
		box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
		font-family: Roboto;
		border: 1px solid rgba(255, 255, 255, 100);
	}

	.baseInfo-wrap {
		position: absolute;
		width: 100%;
	}

	.car-list li .el-row {
		padding: 2px 0;
		color: rgba(16, 16, 16, 100);
		font-size: 14px;
		text-align: left;
		font-family: SourceHanSansSC-regular;
	}

	.hidden-text {
		overflow: hidden;
		white-space: normal;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		width: 200px;
	}

	.car-list li {
		/* border: 1px solid red; */

		border-bottom: 1px solid #ccc;
	}

	.car-list li:hover {
		background-color: #ececec;
		cursor: pointer;
	}

	.list-change {
		padding-bottom: 10px;
	}

	.list-change .active {
		background-color: #fff;
	}

	.list-change span {
		display: inline-block;
		width: 130px;
		background-color: rgba(243, 246, 249, 100);
		color: rgba(56, 148, 255, 100);
		font-size: 14px;
		text-align: center;
		font-family: Roboto;
		padding: 10px;
		font-weight: bold;
		text-align: center;
		/* padding:10px;
  color: #3894FF;
  background-color:#fff; */
	}

	.statusText::before {
		content: "";
		position: relative;
		left: 6px;
		top: -4px;
		border: 1px solid #fddd74;
		background-color: #fddd74;
		display: inline-block;
		width: 5px;
		height: 5px;
		border-radius: 50%;
		margin-right: 12px;
	}

	.statusText:nth-child(1)::before {
		border: 1px solid #76de79;
		background-color: #76de79;
	}

	.statusText:nth-child(3)::before {
		border: 1px solid grey;
		background-color: grey;
	}

	.statusText.offline::before {
		border: 1px solid grey;
		background-color: grey;
	}

	.statusText.static::before {
		border: 1px solid #fddd74;
		background-color: #fddd74;
	}

	.statusText.static {
		color: #000000 65%;
	}

	.statusText.online::before {
		border: 1px solid #76de79;

		background-color: #76de79;
	}

	.statusText.online {
		color: #000000 65%;
	}

	.total-wrap {
		display: flex;
		height: 94%;
		border: 1px solid #ccc;
	}

	.statusDescBar {
		position: relative;
	}

	.statusDescBar .top {
		position: absolute;
		top: 20px;
		display: flex;
		justify-content: space-around;
		left: 355px;
		z-index: 99;
		width: 180px;
		height: 30px;
		padding: 4px 10px;
		line-height: 30px;
		background-color: #fff;
		border-radius: 3px;
		box-shadow: 2px 2px 10px #909090;
		/* border: 1px solid red; */
		left: 418px;
		line-height: 28px;
		height: 33px;
		top: 24px;
	}

	.statusDescBar .top2 {
		position: absolute;
		top: 20px;
		display: flex;
		justify-content: space-around;
		left: 355px;
		z-index: 99;
		width: 180px;
		height: 30px;
		/* padding: 4px 10px; */
		line-height: 30px;
		/* background-color: #fff; */
		border-radius: 3px;
		box-shadow: 2px 2px 10px #909090;
		/* border: 1px solid red; */
		left: 418px;
		line-height: 28px;
		/* height: 33px; */
		top: 24px;
	}

	.title-l {
		/* width: 48px;
  height: 20px; */
		font-size: 12px;

		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.45);
		line-height: 20px;
		margin-bottom: 5px;
	}

	.side {
		width: auto;
		height: 100%;
		overflow-y: auto;
	}

	.main {
		flex: 1;
	}

	/* 图标区域 */
	.graph-wrap {
		/* position: absolute; */
		width: 420px;
		/* right: 0px; */
		/* z-index: 999; */
		height: 100%;
		overflow-y: auto;
		border: 1px solid #ccc;
	}

	.car-list {
		margin: 0;
		padding: 0 8px;
		list-style: none;
		width: 250px;
		height: 90%;
		position: relative;
	}

	.car-list li {
		box-sizing: border-box;
		width: 100%;
		padding: 8px;
		cursor: default;
	}

	.car-list li.hover,
	.car-list li.active {
		background-color: #e5e5e5;
	}

	.car-list .name {
		width: 100%;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow-x: hidden;
	}

	.car-list .bar {
		padding: 4px 0 0;
	}

	.car-list .bar-inner {
		height: 8px;
	}

	.JNPF-common-layout-center .JNPF-common-layout-main {
		padding-bottom: 0;
	}

	.car-list-history {
		margin: 0;
		padding: 30px 8px;
		list-style: none;
		/* width: 250px; */
		width: 300px;
		height: 100%;
		position: relative;
	}

	.car-list-history li {
		box-sizing: border-box;
		width: 100%;
		padding: 8px;
		cursor: default;
		border-bottom: 1px solid #ccc;
		border-top: 1px solid #ccc;
	}

	.car-list-history li.hover,
	.car-list-history li.active {
		background-color: #e5e5e5;
	}

	.baseSty {
		text-align: center;
		height: 30px;
		line-height: 30px;
		color: #e5e5e5;
		margin-bottom: 20px;
	}
</style>
